import { render, staticRenderFns } from "./RinvRLAction.vue?vue&type=template&id=13fbb7a3"
import script from "./RinvRLAction.vue?vue&type=script&lang=js"
export * from "./RinvRLAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports